<div class="c-search-input">
	<input type="text" [placeholder]="PLACEHOLDER_LABEL" [formControl]="control" (keydown.enter)="emit()" />
	<button (click)="emit()">
		<tvcore-icon name="search"></tvcore-icon>
		<span *ngIf="SEARCH_LABEL">{{ SEARCH_LABEL }}</span>
	</button>
</div>
